import { Fragment } from 'react'
import PropTypes from 'prop-types'

const Step = ({ step, currentStep, children }) => {
  if (currentStep !== step) {
    return null
  }

  return <Fragment>{children}</Fragment>
}

Step.propTypes = {
  step: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
}

Step.defaultProps = {
  step: 1,
  currentStep: 1
}

export default Step
